import { Component } from '@angular/core';

@Component({
  selector: 'well-wip-message',
  templateUrl: './wip-message.component.html',
  styleUrls: ['./wip-message.component.scss'],
})
export class WipMessageComponent {}
